export default __webpack_public_path__ + "static/media/control_estado_fetal_intraparto.a46d78eb.pdf";